import React, { useEffect, useState } from "react";
import PublishedRecord from "../PublishedRecord/PublishedRecord";
import AccountCategory from "./AccountCategory";
import ClinicAddress from "./ClinicAddress";
import Compliances from "./Compliances";
import EmailInfo from "./Email";
import Payment from "./Payment";
import PersonalInfo from "./PersonalInfo";
import PrimaryDetails from "./PrimaryDetails";
import SearchSelectDoctor from "./SearchSelectDoctor";
import { useFormik } from "formik";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchDoctors, modifyDoctor } from "../../../../redux/Thunk/Doctor/DoctorThunks";
import { setDoctorById } from "../../../../redux/Reducer/Doctor/DoctorSlice";
import {
  createDoctorValidation,
  upiValidation,
} from "../../../common/Validation/createOrderValidation";
import Loader from "../../../Loader";
import { toast } from "react-hot-toast";

const Doctor = () => {
  const dispatch = useDispatch();

  const { doctors, doctorById, loading } = useSelector(
    ({ doctor }) => ({
      doctors: doctor?.doctors,
      doctorById: doctor?.doctorById,
      loading: doctor?.loading,
    }),
    shallowEqual
  );
  const [selectedDoctor, setSelectedDoctor] = useState({});
  const [selectedOption, setSelectedOption] = useState("");
  const [editingField, setEditingField] = useState(null);
  const [showEditIcon, setShowEditIcon] = useState(false);

  const handleUpdateDoctor = async (values) => {
    if (selectedOption === "upi") {
      values.paymentDetails.accountName = "";
      values.paymentDetails.bankAccountNumber = "";
      values.paymentDetails.bankName = "";
      values.paymentDetails.ifscName = "";
    } else if (selectedOption === "bank") {
      values.paymentDetails.upiId = "";
    }
    const id = values?.doctorDetails.DID;
    try {
      const response = await dispatch(
        modifyDoctor({ id, updatedData: values })
      ).unwrap();
      if (response?.status === 200) {
        handleEditIconClick(null);
        setShowEditIcon(false);
        setSelectedDoctor("");
        formik.resetForm({
          values: formik.initialValues,
        });
      } else {
        if (
          response?.response?.data?.error ===
          `Key ("gstNumber")=(${(values.compliances?.gstNumber).trim()}) already exists.`
        ) {
          toast.error("GST number already exists in the system.");
        } else if (
          response?.response?.data?.error ===
          `Key ("contactNumber")=(${(formik?.values.doctorDetails?.contactNumber).trim()}) already exists.`
        ) {
          toast.error("Contact Number already exist!!");
        } else {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      console.error("Complete Error Object:", error);
    }
  };

  const isNewDoctor = useSelector((state) => state.isNewDoctor);
  const formik = useFormik({
    initialValues: {
      doctorDetails: {
        DID: "",
        contactNumber: "",
        pin: "",
        pinB: "",
      },
      compliances: {
        gstNumber: "",
        registrationNumber: "",
      },
      accountCategory: {
        category: "",
      },
      personalInfo: {
        name: "",
        surname: "",
        clinicName: "",
        tagline: "",
        qualificationSpecialisation: "",
        experience: 0,
        operatorName: "",
        managerName: "",
        about1: "",
        about2: "",
      },
      clinicAddress: {
        premisesNo: "",
        floor: "",
        premisesName: "",
        landmark: "",
        areaRoad: "",
        city: "",
        pinCode: "",
        state: "",
        clinicContactNumber: "",
        googleMapUrl: "",
      },
      emailInfo: {
        doctorEmail: "",
        clinicEmail: "",
      },
      paymentDetails: {
        bankAccountNumber: "",
        accountName: "",
        bankName: "",
        ifscName: "",
        upiId: "",
      },
    },
    validationSchema:
      selectedOption === "bank" ? createDoctorValidation : upiValidation,
      onSubmit: handleUpdateDoctor,
    validateOnChange: true,
     
  });
  const getFormValuesFromDoctorById = (doctorById) => ({
    doctorDetails: {
      DID: doctorById?.DID || "",
      contactNumber: doctorById?.contactNumber || "",
      pin: doctorById?.pin || "",
      pinB: doctorById?.pinB || "",
      autoSignature:doctorById?.autoSignature
    },
    compliances: {
      gstNumber: doctorById?.compliance?.gstNumber || "",
      registrationNumber: doctorById?.compliance?.registrationNumber || "",
    },
    accountCategory: {
      category: doctorById?.accountCategory?.category || "General",
    },
    personalInfo: {
      name: doctorById.personalInfo?.name || "",
      surname: doctorById?.personalInfo?.surname || "",
      clinicName: doctorById?.personalInfo?.clinicName || "",
      tagline: doctorById?.personalInfo?.tagline || "",
      qualificationSpecialisation:
        doctorById?.personalInfo?.qualificationSpecialisation || "",
      experience: doctorById?.personalInfo?.experience || 0,
      operatorName: doctorById?.personalInfo?.operatorName || "",
      managerName: doctorById?.personalInfo?.managerName || "",
      about1: doctorById?.personalInfo?.about1 || "",
      about2: doctorById?.personalInfo?.about2 || "",
    },
    clinicAddress: {
      premisesNo: doctorById?.clinicAddress?.premisesNo || "",
      floor: doctorById?.clinicAddress?.premisesNo || "",
      premisesName: doctorById?.clinicAddress?.premisesName || "",
      landmark: doctorById?.clinicAddress?.landmark || "",
      areaRoad: doctorById?.clinicAddress?.areaRoad || "",
      city: doctorById?.clinicAddress?.city || "",
      pinCode: doctorById?.clinicAddress?.pinCode || "",
      state: doctorById?.clinicAddress?.state || "",
      clinicContactNumber: doctorById?.clinicAddress?.clinicContactNumber || "",
      googleMapUrl: doctorById?.clinicAddress?.googleMapUrl || "",
    },
    emailInfo: {
      doctorEmail: doctorById?.emailInfo?.doctorEmail || "",
      clinicEmail: doctorById?.emailInfo?.clinicEmail || "",
    },
    paymentDetails: {
      bankAccountNumber: doctorById?.paymentDetail?.bankAccountNumber || "",
      accountName: doctorById?.paymentDetail?.accountName || "",
      bankName: doctorById?.paymentDetail?.bankName || "",
      ifscName: doctorById?.paymentDetail?.ifscName || "",
      upiId: doctorById?.paymentDetail?.upiId || "",
    },
  });
  useEffect(() => {
    if (!Object.keys(doctorById)?.length) {
      formik.resetForm({
        values: formik.initialValues, // Resetting to initial values
      });
      setShowEditIcon(false);
    } else {
      const newValues = getFormValuesFromDoctorById(doctorById);
      formik.setValues(newValues);
      if (doctorById?.paymentDetail?.bankAccountNumber) {
        setSelectedOption("bank");
      } else {
        setSelectedOption("upi");
      }
      formik.validateForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doctorById]);

  useEffect(() => {
    dispatch(fetchDoctors());
  }, [dispatch]);

  useEffect(() => {
    dispatch(setDoctorById({}));
  }, [dispatch]);

  useEffect(() => {
    setShowEditIcon(false);
  }, [selectedDoctor]);
  const date = new Date(doctorById?.createdAt);

  // Format the date to MM/DD/YYYY using toLocaleDateString
  const formattedDate = date?.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const handleEditButtonClick = () => {
    setShowEditIcon(true);
  };

  const handleEditIconClick = (fieldName) => {
    if (editingField !== fieldName) {
      setEditingField(fieldName);
      setTimeout(() => handleFocus(fieldName), 0);
    }
  };

  const handleBlur = (fieldName) => {
    if (editingField === fieldName) {
      setEditingField(null);
    }
  };
  const handleFocus = (fieldName) => {
    const inputField = document.getElementById(fieldName);

    if (inputField) {
      inputField.focus();
    }
  };

  let isDisabled = Object.keys(doctorById)?.length ? true : false;
  return (
    <>
      {!isNewDoctor ? (
        <>
          <section className="tab-doctor">
            <Loader loading={loading} />
            <form
              className="dashboard-container"
              onSubmit={formik.handleSubmit}
            >
              <SearchSelectDoctor
                doctors={doctors}
                formik={formik}
                type="listing"
                selectedDoctor={selectedDoctor}
                setSelectedDoctor={setSelectedDoctor}
              />
              {formik?.values?.doctorDetails?.DID && (
                <div className="bg-gray-100 py-3 px-5 rounded-[12px] mt-3">
                  <PrimaryDetails
                    formik={formik}
                    isEdit={showEditIcon}
                    handleEditIconClick={handleEditIconClick}
                    handleBlur={handleBlur}
                    editingField={editingField}
                    isDisabled={isDisabled}
                    handleFocus={handleFocus}
                  />
                  <Compliances
                    formik={formik}
                    isEdit={showEditIcon}
                    handleEditIconClick={handleEditIconClick}
                    handleBlur={handleBlur}
                    editingField={editingField}
                    isDisabled={isDisabled}
                  />
                  <AccountCategory
                    formik={formik}
                    showEditIcon={showEditIcon}
                    isDisabled={isDisabled}
                  />
                  <PersonalInfo
                    formik={formik}
                    isEdit={showEditIcon}
                    handleEditIconClick={handleEditIconClick}
                    handleBlur={handleBlur}
                    editingField={editingField}
                    isDisabled={isDisabled}
                  />
                  <ClinicAddress
                    formik={formik}
                    isEdit={showEditIcon}
                    handleEditIconClick={handleEditIconClick}
                    handleBlur={handleBlur}
                    editingField={editingField}
                    isDisabled={isDisabled}
                  />
                  <EmailInfo
                    formik={formik}
                    isEdit={showEditIcon}
                    handleEditIconClick={handleEditIconClick}
                    handleBlur={handleBlur}
                    editingField={editingField}
                    isDisabled={isDisabled}
                  />
                  <Payment
                    formik={formik}
                    setSelectedDoctor={setSelectedDoctor}
                    formattedDate={formattedDate}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    handleEditToggle={handleEditButtonClick}
                    isEdit={showEditIcon}
                    handleEditIconClick={handleEditIconClick}
                    handleBlur={handleBlur}
                    editingField={editingField}
                    setShowEditIcon={setShowEditIcon}
                    isDisabled={isDisabled}
                    showEditIcon={showEditIcon}
                    resetValues={getFormValuesFromDoctorById}
                    doctorById={doctorById}
                  />
                </div>
              )}
            </form>
          </section>
          {formik?.values?.doctorDetails?.DID && (
            <PublishedRecord
              DID={formik?.values?.doctorDetails?.DID}
              date={date}
            />
          )}
        </>
      ) : null}
    </>
  );
};

export default Doctor;
